<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="isAvailableToSave"
    :isCancel="!isAvailableToSave"
    @command="setCommand"
  >
    <form-users
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        :hasCreateNew="hasCreateNew"
        ref="Form"/>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isClipboard="hasCreateNew"
        @command="setCommand"
      />
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorLinks',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-users': () => import(/* webpackChunkName: 'UsersManagement' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'AppUsers/Patch/${data.id}'
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.get('currentUser')
    },
    formTitle () {
      return (this.formData.appUserID) ? `${this.formData.firstName} ${this.formData.lastName}` : this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        appUserID: '',
        thumbnailPath: '',
        firstName: '',
        lastName: '',
        email: '',
        roleID: null,
        employeeID: null,
        isActive: false,
        userPath: ''
      }
    }
  }
}
</script>

<style lang="stylus">
</style>
